import './utils.js';
import { faker } from 'https://cdn.jsdelivr.net/npm/@faker-js/faker/+esm';

/**
 * Initializes LogRocket for the microapp.
 */
const initLogRocket = () => {
  window.emuiLogrocket.initLogRocket({ isReact: false });
};

/**
 * Reports an issue to LogRocket.
 */
const reportIssue = () => {
  if (window.emuiLogrocket) {
    window.emui.logRocket.captureMessage('Unable to process request', {
      description: 'An error occurred while processing the request.',
      severity: 'error',
    });
  }
};

/**
 * Event handler for the "lorem-ipsum-btn" button click event.
 */
const onLoremIpsumClick = () => {
  const loremIpsumText = document.getElementById('lorem-ipsum-text');
  loremIpsumText.textContent = faker.lorem.paragraph();
  reportIssue();
};

/**
 * Event handler for the window load event.
 */
const onLoad = () => {
  const loremIpsumBtn = document.getElementById('lorem-ipsum-btn');
  loremIpsumBtn.addEventListener('click', onLoremIpsumClick);
};

if (window.emuiLogrocket) initLogRocket();
window.addEventListener('load', onLoad);
